import en_US from './en_US.json';
import pt_BR from './pt_BR.json';

// This is the list of all available locales that your MFE supports
// You reuse the same locale file for multiple locales if they share the same translations

export default {
  en_US,
  pt_BR,
  pt_PT: pt_BR
};

type LocaleMapping = {
  [key: string]: string;
};

export const localeToContentStack: LocaleMapping = {
  'ar-sa': 'ar-sa',
  'bg-bg': 'bg-bg',
  'ca-es': 'ca-es',
  'cs-cz': 'cs-cz',
  'da-dk': 'da-dk',
  'de-at': 'de-de',
  'de-ch': 'de-de',
  'de-de': 'de-de',
  'de-li': 'de-de',
  'de-lu': 'de-de',
  'el-cy': 'el-gr',
  'el-gr': 'el-gr',
  'en-ae': 'en-us',
  'en-af': 'en-us',
  'en-ag': 'en-us',
  'en-ai': 'en-us',
  'en-al': 'en-us',
  'en-au': 'en-us',
  'en-aw': 'en-us',
  'en-az': 'en-us',
  'en-ba': 'en-us',
  'en-bb': 'en-us',
  'en-bd': 'en-us',
  'en-bh': 'en-us',
  'en-bn': 'en-us',
  'en-bs': 'en-us',
  'en-bt': 'en-us',
  'en-bw': 'en-us',
  'en-bz': 'en-us',
  'en-ca': 'en-us',
  'en-cm': 'en-us',
  'en-cr': 'en-us',
  'en-cy': 'en-us',
  'en-dz': 'en-us',
  'en-eg': 'en-us',
  'en-et': 'en-us',
  'en-gb': 'en-gb',
  'en-gd': 'en-us',
  'en-ge': 'en-us',
  'en-gh': 'en-us',
  'en-hk': 'en-us',
  'en-id': 'en-us',
  'en-ie': 'en-us',
  'en-il': 'en-us',
  'en-in': 'en-us',
  'en-is': 'en-us',
  'en-jm': 'en-us',
  'en-jo': 'en-us',
  'en-jp': 'en-us',
  'en-ke': 'en-us',
  'en-kh': 'en-us',
  'en-kn': 'en-us',
  'en-kw': 'en-us',
  'en-ky': 'en-us',
  'en-la': 'en-us',
  'en-lb': 'en-us',
  'en-lc': 'en-us',
  'en-lk': 'en-us',
  'en-ly': 'en-us',
  'en-ma': 'en-us',
  'en-me': 'en-us',
  'en-mk': 'en-us',
  'en-mm': 'en-us',
  'en-mn': 'en-us',
  'en-ms': 'en-us',
  'en-mt': 'en-us',
  'en-mu': 'en-us',
  'en-mv': 'en-us',
  'en-my': 'en-us',
  'en-na': 'en-us',
  'en-ng': 'en-us',
  'en-np': 'en-us',
  'en-nz': 'en-us',
  'en-om': 'en-us',
  'en-ph': 'en-us',
  'en-pk': 'en-us',
  'en-pr': 'en-us',
  'en-qa': 'en-us',
  'en-rs': 'en-us',
  'en-rw': 'en-us',
  'en-sa': 'en-us',
  'en-sg': 'en-us',
  'en-sx': 'en-us',
  'en-tc': 'en-us',
  'en-th': 'en-us',
  'en-tl': 'en-us',
  'en-tn': 'en-us',
  'en-tt': 'en-us',
  'en-tw': 'en-us',
  'en-tz': 'en-us',
  'en-ug': 'en-us',
  'en-us': 'en-us',
  'en-vc': 'en-us',
  'en-vg': 'en-us',
  'en-vi': 'en-us',
  'en-vn': 'en-us',
  'en-za': 'en-us',
  'en-zm': 'en-us',
  'es-ar': 'es-es',
  'es-bo': 'es-es',
  'es-cl': 'es-es',
  'es-co': 'es-es',
  'es-cu': 'es-es',
  'es-do': 'es-es',
  'es-ec': 'es-es',
  'es-es': 'es-es',
  'es-gt': 'es-es',
  'es-hn': 'es-es',
  'es-mx': 'es-es',
  'es-ni': 'es-es',
  'es-pa': 'es-es',
  'es-pe': 'es-es',
  'es-pr': 'es-es',
  'es-py': 'es-es',
  'es-sv': 'es-es',
  'es-uy': 'es-es',
  'es-ve': 'es-es',
  'et-ee': 'et-ee',
  'fi-fi': 'fi-fi',
  'fr-be': 'fr-fr',
  'fr-bj': 'fr-fr',
  'fr-bl': 'fr-fr',
  'fr-ca': 'fr-fr',
  'fr-ch': 'fr-fr',
  'fr-ci': 'fr-fr',
  'fr-fr': 'fr-fr',
  'fr-gf': 'fr-fr',
  'fr-gp': 'fr-fr',
  'fr-ht': 'fr-fr',
  'fr-lc': 'fr-fr',
  'fr-lu': 'fr-fr',
  'fr-mf': 'fr-fr',
  'fr-mg': 'fr-fr',
  'fr-mq': 'fr-fr',
  'fr-nc': 'fr-fr',
  'fr-pf': 'fr-fr',
  'fr-re': 'fr-fr',
  'fr-sn': 'fr-fr',
  'fr-yt': 'fr-fr',
  'he-il': 'he-il',
  'hr-hr': 'hr-hr',
  'hu-hu': 'hu-hu',
  'id-id': 'id-id',
  'it-ch': 'it-it',
  'it-it': 'it-it',
  'ja-jp': 'ja-jp',
  'ko-kr': 'ko-kr',
  'lt-lt': 'lt-lt',
  'lv-lv': 'lv-lv',
  'mt-mt': 'mt-mt',
  'nb-no': 'nb-no',
  'nl-be': 'nl-nl',
  'nl-bq': 'nl-nl',
  'nl-cw': 'nl-nl',
  'nl-nl': 'nl-nl',
  'pl-pl': 'pl-pl',
  'pt-ao': 'pt-pt',
  'pt-br': 'pt-br',
  'pt-mz': 'pt-pt',
  'pt-pt': 'pt-pt',
  'ro-md': 'ro-ro',
  'ro-ro': 'ro-ro',
  'ru-by': 'ru-ru',
  'ru-kz': 'ru-ru',
  'ru-ru': 'ru-ru',
  'ru-ua': 'ru-ru',
  'ru-uz': 'ru-ru',
  'sk-sk': 'sk-sk',
  'sl-si': 'sl-si',
  'sv-fi': 'sv-se',
  'sv-se': 'sv-se',
  'th-th': 'th-th',
  'tr-tr': 'tr-tr',
  'uk-ua': 'uk-ua',
  'zh-cn': 'zh-cn',
  'zh-hk': 'zh-hk',
  'zh-tw': 'zh-tw'
};
